// extracted by mini-css-extract-plugin
module.exports = {"copyright":"CopyrightFooter_copyright__3ym59"};